module.exports = __webpack_public_path__ + "img/checks.d78edbf0.svg";